module.exports = __webpack_public_path__ + "img/iriomote_1.cb86a81d.jpg";